import { Card, CardContent, Typography, Grid, Box } from '@mui/material';
import { useTranslation } from "react-i18next";

const PassportCard = ({ item }) => {
    const { t } = useTranslation();
    const passportData = JSON.parse(item.passportData);
    const fields = [
        { label: t('profile.passport_name'), value: item.firstName },
        { label: t('profile.passport_middlename'), value: item.middleName },
        { label: t('profile.passport_surname'), value: item.lastName },
        { label: t('profile.birthday'), value: item.birthday },
        {
            label: t('profile.passport_sex'),
            value: item.id_PersonSex===1?t('profile.passport_man') : t('profile.passport_woman')
        },
        { label: t('profile.passport_series'), value: passportData?.series },
        { label: t('profile.passport_number'), value: passportData?.number },
        { label: t('profile.passport_dateGot'), value:passportData?.date },
        { label: t('profile.passport_dateExp'), value:passportData?.expiredDate },
    ];

    return (
        <div className="flex justify-center items-center p-4">
            <Card
                sx={{
                    width: 400,
                    // background: 'linear-gradient(135deg, #6b7280 0%, #a5d6a7 100%)',
                    background: '#a5d6a7',
                    color: '#000000',
                    borderRadius: '16px',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
                    position: 'relative',
                    overflow: 'hidden',

                }}
            >
                {/* Background Pattern */}
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M0 0h20v20H0z'/%3E%3Cpath d='M10 10l5-5m0 5l-5-5m-5 5l5-5m0 5l-5-5' stroke='%23ffffff' stroke-opacity='0.2'/%3E%3C/g%3E%3C/svg%3E")`,
                        opacity: 0.2,
                    }}
                />

                <CardContent sx={{ position: 'relative', zIndex: 1, padding: '24px' }}>
                    {/* Header */}
                    <Typography variant="h5" component="div" align="center" gutterBottom sx={{ fontWeight: 'bold', letterSpacing: '1px' }}>
                        {t('profile.passport_header')}
                    </Typography>

                    {/* Data Grid */}
                    <Grid container spacing={2}>
                        {fields.map((field, index) => (
                            <Grid item xs={6} key={index}>
                                <Typography variant="caption" sx={{ opacity: 0.8, fontWeight: 'medium' }}>
                                    {field.label}
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'medium', fontSize: '1.1rem' }}>
                                    {field.value}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>

                {/* Holographic Effect */}
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                        animation: 'holographic 3s ease-in-out infinite',
                    }}
                />
            </Card>
        </div>
    );
};

export default PassportCard;